import { addSpaceIfNeeded } from "../addSpaceIfNeeded";

export const addAOChartToLayout = (newLayout, format, campaignId, provider) => {
  const lastEl = addSpaceIfNeeded("overlap-chart", newLayout, format);

  const x = 4;
  const y = lastEl.y;
  const w = 8;
  const h = 3;

  const i = `overlap-chart-${provider}-${campaignId}`;
  newLayout.push({ i, x, y, w, h });
};
